<template>
  <!-- 通用套题 -->
  <div class="word-reading-panel common-panel" v-if="isReady">
    <div class="panel-content">
      <div class="panel-content-stem">
        {{ serial ? serial + ". " : "" }}{{ getStemText || $t("textbook_reading_comprehension_stem") }}
      </div>
      <div class="panel-content-reading">
        <p class="title">{{ currItem.title }}</p>
        <div class="panel-content-reading-article">
          <div v-if="currItem.config && currItem.config.same_option" class="item-list">
            <div v-if="currItem.answers" :class="[`item-${currItem.answers[0].type}`]">
              <div v-for="(item, index) in currItem.answers" :key="index">
                <!-- 图片 -->
                <div v-if="item.type == 'image'" class="single-item">
                  <div class="item-key">{{ item.flag }}</div>
                  <div class="item-content">
                    <img :src="baseUrl + item.content + '?width=300'" alt="" />
                  </div>
                </div>
                <!-- html/text/syllable -->
                <div v-else class="single-item">
                  <div class="item-key">{{ item.flag }}</div>
                  <PhoneticText :showPinyin="true" :originData="item.content" :baseStyles="textBlackStyles">
                  </PhoneticText>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            :class="['text', text.style && text.style.align ? 'text-' + text.style.align : '']"
            v-for="(text, index) in currItem.top_screen_text || currItem.screen_text"
            :key="index"
          >
            <img :src="baseUrl + text.content + '?width=300'" alt="" v-if="text.type === 'image'" />
            <PhoneticText
              v-else-if="text.type === 'html' || text.type === 'text' || text.type === 'syllable'"
              :originData="text.content"
              :baseStyles="textStyles(text)"
              :showPinyin="text.display != 1"
              :onlyPinyin="text.display == 2"
            ></PhoneticText>
            <!-- 此处未兼容题干带音频的题型,如需兼容需要根据数据调试 -->
            <div class="panel-content-options" v-else-if="text.type === 'audio'">
              <ButtonTool
                type="play"
                @click.native="clickPlayTopVoice(text.content)"
                v-show="topPlayStatus == 'play'"
              ></ButtonTool>
              <!-- <CricleTimer
                v-show="topPlayStatus == 'pause' && !isShowAnAnalysis"
                v-if="middleTime"
                :start-time="startTime"
                :middle-time="middleTime"
                :step="-1"
                :thresholds="[
                  {
                    color: '#f6f8fa',
                    threshold: startTime > 60 ? 0.01 : 0.1,
                  },
                ]"
                :width="70"
                :height="70"
              >
                <ButtonTool slot="content" type="playHsk" :disabled="true"></ButtonTool>
              </CricleTimer> -->
              <ButtonTool
                type="pause"
                @click.native="clickPauseTopVoice"
                v-if="topPlayStatus == 'pause' && !isShowAnAnalysis"
              ></ButtonTool>
              <ButtonTool
                v-show="topPlayStatus == 'pause' && isShowAnAnalysis"
                @click.native="clickPauseTopVoice"
                type="pause"
                slot="content"
              ></ButtonTool>
            </div>
          </div>
        </div>
        <div
          class="panel-content-reading-questions"
          v-for="(question, qindex) in filterQuestionList"
          :key="question.index"
        >
          <!-- 小题题干 -->
          <span style="color: #b5b5be"
            >{{
              question.is_example ? $t("hsk_example") : serial ? Number(serial.split("-")[0]) + qindex : question.index
            }}.</span
          >
          <div class="description">
            {{ question.question_description_obj.zh }}
          </div>
          <div class="description" v-for="(item, index) in question.screen_text" :key="index">
            <img :src="baseUrl + item.content + '?width=300'" alt="" v-if="item.type === 'image'" />
            <PhoneticText
              v-else-if="item.type === 'html' || item.type === 'text' || item.type === 'syllable'"
              :originData="item.content"
              :baseStyles="smallTextStyles"
              :showPinyin="item.display != 1"
              :onlyPinyin="item.display == 2"
            ></PhoneticText>
            <div v-if="item.type === 'audio'">
              <img
                class="audio_bg"
                v-show="(isSpecial || !isExamMode) && (question.playStatus == 'play' || !question.playStatus)"
                @click="clickSmallVoice(qindex, index, item.content, 'pause')"
                :src="iconPlay('play')"
                alt=""
                width="40"
                height="40"
              />
              <!-- <CricleTimer
                v-show="question.playStatus == 'pause'"
                v-if="middleTime && !isSpecial"
                :start-time="startTime"
                :middle-time="middleTime"
                :step="-1"
                :thresholds="[
                  {
                    color: '#f6f8fa',
                    threshold: startTime > 60 ? 0.01 : 0.1,
                  },
                ]"
                :width="40"
                :height="40"
              >
                <img slot="content" :src="iconPlay('playHsk')" alt="" width="45" height="45" />
              </CricleTimer> -->
              <img
                class="audio_bg"
                v-show="(isSpecial || !isExamMode) && question.playStatus == 'pause'"
                @click="clickSmallVoice(qindex, index, item.content, 'play')"
                :src="iconPlay('pause')"
                alt=""
                width="40"
                height="40"
              />
            </div>
          </div>
          <!-- 小题选项 -->
          <div :class="[currItem.config && currItem.config.same_option ? 'options-small' : 'options']">
            <div
              v-for="option in question.answers"
              :key="option.index"
              :class="[
                'option-item',
                {
                  selected: option.selected || (question.is_example && option.correct),
                  success: isShowAnAnalysis && option.correct,
                  error: isShowAnAnalysis && option.selected && !option.correct,
                },
              ]"
              :data-correct="option.correct ? 1 : 0"
              @click="clickQuestionChoice($event, question, option)"
            >
              <div v-if="currItem.config && currItem.config.same_option">
                <span class="item-key">{{ option.flag }}</span>
              </div>
              <template v-else>
                <span class="item-key">{{
                  question.question_type == "eb" || question.question_type == "ed" ? option.flag : ""
                }}</span>
                <div v-if="question.question_type == 'eb' || question.question_type == 'ed'">
                  <img :src="baseUrl + option.content + '?width=300'" alt="" v-if="option.type === 'image'" />
                  <PhoneticText
                    v-else-if="option.type === 'html' || option.type === 'text' || option.type === 'syllable'"
                    :originData="option.content"
                    :baseStyles="smallTextStyles"
                    :showPinyin="option.display != 1"
                    :onlyPinyin="option.display == 2"
                  ></PhoneticText>
                </div>
              </template>
            </div>
          </div>
          <!-- 解析 -->
          <div
            class="panel-content-result result-correct"
            v-if="isShowAnAnalysis && !question.is_example && question.myAnswerText == question.successAnswerText"
          >
            <p class="correct-tips">
              {{ $t("textbook_chioce_word_text_correct_tip") }}
            </p>
            <div class="correct-box" v-show="question.analysisText">
              <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
              <p class="correct-box-answer">
                {{ question.analysisText }}
              </p>
            </div>
          </div>

          <div
            class="panel-content-result result-error"
            v-if="isShowAnAnalysis && !question.is_example && question.myAnswerText != question.successAnswerText"
          >
            <p class="error-tips">
              {{ $t("textbook_chioce_word_text_error_tip") }}
            </p>
            <div class="result-show">
              <div class="your-answer">{{ $t("hsk_your_answer") }}{{ question.myAnswerText }}</div>
              <p class="correct-answer">{{ $t("hsk_correct_answer") }}{{ question.successAnswerText }}</p>
            </div>
            <div class="correct-box" v-show="question.analysisText">
              <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
              <p class="correct-box-answer">
                {{ question.analysisText }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mixinCommon } from "@/mixins";
import PhoneticText from "@/components/ui/phoneticText";
// import CricleTimer from "@/components/ui/CricleTimer/index.vue";
import { VOICE_EXTEND_TIME } from "@/config";

export default {
  name: "CommonReadingComprehension",
  mixins: [mixinCommon],
  components: {
    PhoneticText,
    // CricleTimer,
  },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 侧边栏状态
      showSidebar: true,
      // 是否禁止点击
      isDisabled: false,
      // 是否正确
      isCorrect: false,
      // 当前试题正确答案
      currCorrectAnswer: [],
      // 是否完成
      isFinished: false,
      icons: {
        play: require("@/assets/images/btn_play_hsk.png"),
        pause: require("@/assets/images/btn_pause_hsk.png"),
        playHsk: require("@/assets/images/play_hsk.png"),
      },
      topPlayStatus: "play",
      changeBtn: false,
      startTime: 0,
      middleTime: 0,
    };
  },
  computed: {
    isReady() {
      return !!this.jsonData;
    },
    language() {
      let local = localStorage.getItem("language");
      return local;
    },
    getStemText() {
      return (this.currItem.question_description_obj && this.currItem.question_description_obj[this.language]) || "";
    },
    textBlackStyles() {
      return {
        // 拼音文本初始颜色
        originPinyinColor: "#3F4651",
        // 拼音文本字体大小
        pinyinFontSize: "10px",
        // 拼音文本 行高
        pinyinLineHeight: "14px",
        // 汉字文本初始颜色
        originHzColor: "#3E4651",
        // 拼音文本字体大小
        hzFontSize: "15px",
        // 汉字文本 行高
        hzLineHeight: "25px",
        // 行文 间距(下方间距)
        writingSpacing: "0px",
        // 分词间距
        wordSpacing: "10px",
      };
    },
    filterQuestionList() {
      let questionsList = this.currItem.questions;
      //根据当前语言显示分析
      questionsList
        .filter(function (item) {
          return !item.is_example;
        })
        .map((item, index) => {
          item.analysisText = item.analysis[this.language] ? item.analysis[this.language] : item.analysis["cn"];

          if (this.currItem.answer && this.currItem.answer.length > 0 && !this.changeBtn) {
            for (let i = 0; i < item.answers.length; i++) {
              if (item.answers[i].index == this.currItem.answer[index]) {
                item.answers[i].selected = true;
                item.myAnswerText = item.answers[i].flag;
              } else {
                item.answers[i].selected = false;
              }
              if (item.answers[i].correct) {
                item.successAnswerText = item.answers[i].flag;
              }
            }
          }
        });
      return questionsList;
    },
  },
  watch: {
    isReady: {
      handler(val) {
        if (val) {
          // 重新组装数据
          this.currItem = this.jsonData;
          if (this.jsonData.listen && this.jsonData.listen.audio_file) {
            // 已经存在则不添加
            if (!this.currItem.screen_text.find((item) => item.type == "audio")) {
              this.currItem.screen_text.push({
                content: this.jsonData.listen.audio_file,
                type: "audio",
              });
            }
          }
          this.currItem.questions.forEach((item) => {
            if (item.listen && item.listen.audio_file) {
              if (!item.screen_text.find((j) => j.type == "audio")) {
                item.screen_text.push({
                  content: item.listen.audio_file,
                  type: "audio",
                });
              }
            }
          });
          this.currCorrectAnswer = [];
          this.currItem.questions.forEach((question) => {
            if (Array.isArray(question.answers)) {
              let compatibleData = question.answers.map((a) => {
                return {
                  id: a.index,
                  index: a.id,
                  ...a,
                };
              });
              question.answers = compatibleData;
              let correctAnswer = compatibleData.find((answer) => {
                return answer.correct === true;
              });
              correctAnswer &&
                this.currCorrectAnswer.push({
                  question_type: question.question_type,
                  content: correctAnswer.content || correctAnswer.flag,
                });
            }
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.startTime = this.$player.totalTime;
    this.middleTime = this.$player.lastPlayTime;
    if (this.ansProgressStatus == 1) {
      this.resetPlayStatus(this.currItem, "pause", true);
    } else {
      this.middleTime = 0;
    }
  },
  methods: {
    // 小题选项点击事件
    clickQuestionChoice($event, question, option) {
      if (this.isDisabled || question.is_example || this.isShowAnAnalysis) return;

      $event.currentTarget.classList.add("selected");
      const isCorrect = $event.currentTarget.dataset.correct == 1;
      let questions = this.currItem.questions.map((item) => {
        if (item.index === question.index) {
          let questionTemp = {
            ...item,
            ansId: option.id, // 学生作答
            isFinished: true, // 标识已作答
            isCorrect, // 标识是否作答成功
          };
          console.log(questionTemp);
          questionTemp.answers = questionTemp.answers.map((item1) => {
            if (item1.id === option.id) {
              return {
                ...item1,
                selected: true,
              };
            } else {
              return {
                ...item1,
                selected: false,
              };
            }
          });

          return {
            ...questionTemp,
          };
        } else {
          return {
            ...item,
            selected: false,
          };
        }
      });
      this.changeBtn = true;
      this.currItem.questions = questions;

      // 场景一完成做完提交答案
      this.isFinished = !this.currItem.questions.some((item) => !item.isFinished);
      //this.clickPauseTopVoice()
      if (this.isFinished) {
        this.clickSubmit();
      }
      // 场景二做完一题提交一次
      // 作答的对象
      let ansObj = {
        questionId: question.index,
        answer: option.index.toString(),
        judge: isCorrect ? 1 : 0,
        scores: isCorrect == 1 ? question.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
      };

      // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit("saveRes", ansObj);
      });
    },
    // 按钮点击事件
    clickSubmit() {
      if (this.isDisabled) return;
      this.handleSubmit();
    },

    // 提交
    handleSubmit() {
      this.isDisabled = true;
      // 解析答案提交
      let answerResult = [];
      let totalScore = 0;
      let isAllCorrect = true;
      this.currItem.questions.forEach((question) => {
        // 全部小题答题正确，才判定
        if (!question.isCorrect) {
          isAllCorrect = false;
        } else {
          totalScore += question.score;
        }

        // 拼装提交
        answerResult.push({
          questionId: question.index - 0,
          answer: question.ansId + "",
          scores: question.isCorrect ? question.score : 0,
        });
      });

      // 页面反馈答题结果
      this.isCorrect = isAllCorrect;
      let params = {
        answer: JSON.stringify(answerResult),
        questionId: this.jsonData.index,
        scores: totalScore,
      };
      this.resetPlayAllStatus();
      this.topPlayStatus = "play";
      this.$emit("customInterface", params);
      this.isDisabled = false;
    },
    //根据状态显示播放/暂停按钮
    iconPlay(playType) {
      return this.icons[playType];
    },
    // 播放小题音频
    clickSmallVoice(bigIndex, smallIndex, src, status) {
      if (!this.isShowAnAnalysis && !this.isSpecial) return;
      let question = this.currItem.questions.map((ques, qindex) => {
        if (qindex == bigIndex) {
          ques.playStatus = status;
        } else {
          ques.playStatus = "play";
        }
        return { ...ques };
      });
      this.currItem.questions = question;
      let srcUrl = new RegExp("https").test(src) ? src : this.baseUrl + src;
      status !== "play" ? this.$player.play(srcUrl) : this.$player.pause();
      this.$player.onended = () => {
        this.clickSmallVoice(bigIndex, smallIndex, src, "play");
      };
      // 只要点击小题播放则初始化大题播放按钮
      this.topPlayStatus = "play";
    },
    // 重置所有按钮
    resetPlayAllStatus(status) {
      let question = this.currItem.questions.map((ques) => {
        ques.playStatus = "play";
        let text = ques.screen_text.map((text) => {
          return text;
        });
        ques.screen_text = text;
        return { ...ques };
      });
      this.currItem.questions = question;
      !status && this.$player.pause();
    },
    //重置播放状态
    resetPlayStatus(question, status, isClickStatus) {
      let questions = this.currItem.questions.map((item) => {
        let questionIndex = isClickStatus ? question.currentPlayIndex : question.index;
        if (item.index == questionIndex) {
          if (this.isSpecial) {
            item.playStatus = status;
          } else if (this.currItem.bigIndex == question.currentPlayBigIndex) {
            item.playStatus = status;
          } else {
            item.playStatus = "play";
          }
        } else {
          item.playStatus = "play";
        }
        return { ...item };
      });
      this.currItem.questions = questions;
    },
    // 大题音频播放初始化所有小题状态
    clickPlayTopVoice(src) {
      this.topPlayStatus = "pause";
      let srcUrl = new RegExp("https").test(src) ? src : this.baseUrl + src;
      this.$player.play(srcUrl);
      this.$player.onended = () => {
        this.topPlayStatus = "play";
      };
      this.resetPlayAllStatus(true);
    },
    //点击暂停顶部录音
    clickPauseTopVoice() {
      this.topPlayStatus = "play";
      this.$player.pause();
    },
    // 自动播放套题中小题音频
    playAutoVoice(question, isTryAgain) {
      // 播放前重新渲染下组件
      this.middleTime = 0;
      this.resetPlayStatus(question, "pause");
      let audioPath = this.baseUrl + question.screen_text.find((item) => item.type == "audio").content;
      this.$player.play(audioPath, "", {}, isTryAgain);
      const _this = this;
      this.$player.onended = (e) => {
        this.resetPlayStatus(question, "play");
        if (e == "failed") {
          layer.open({
            title: "",
            closeBtn: 0,
            content: _this.$t("common_video_failed"),
            btn: [_this.$t("button_common_start_over"), _this.$t("hsk_skip")],
            yes: (index) => {
              _this.playAutoVoice(question, true);
              layer.close(index);
            },
            btn2: (index) => {
              _this.HSKVoice("HSKVoice", Date.parse(new Date()));
              layer.close(index);
            },
          });
        } else {
          setTimeout(() => {
            _this.HSKVoice("HSKVoice", Date.parse(new Date()));
          }, VOICE_EXTEND_TIME * 1000);
        }
      };
      this.$player.onloaded = (e) => {
        this.startTime = e;
        this.middleTime = e;
        console.log(this.startTime);
      };
    },
    //存在作答的小题时，自动播放未作答的小题音频
    autoPlay(obj) {
      let _obj = JSON.parse(JSON.stringify(obj));
      _obj.screen_text.push({
        content: _obj.listen.audio_file,
        type: "audio",
      });
      this.playAutoVoice(_obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./common.scss";
.correct-box-answer {
  flex-direction: column;
  align-items: flex-start !important;
}
.option-item {
  display: flex !important;
  align-items: center;
  ::v-deep .phtContent {
    .pht_single {
      margin-bottom: 0 !important;
      text-align: start;
    }
  }
  &-small {
    cursor: pointer;
    width: 42px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    background-color: #fafafb;
    border-radius: 2px;
    margin-right: 20px;
    color: #393d46;
    font-size: 14px;
  }
}

.description {
  &:not(:nth-of-type(1)) {
    display: block !important;
  }
  &:nth-of-type(1) {
    color: #b5b5be;
  }
  .audio_bg {
    cursor: pointer;
  }
  ::v-deep .phtContent {
    .pht_single {
      text-align: start;
    }
  }
}
.common-panel .panel-content-reading-article {
  .text {
    margin-bottom: 5px;
    justify-content: flex-start;
  }
  .text-left {
    justify-content: flex-start;
  }
  .text-right {
    justify-content: flex-end;
  }
  .item-list {
    width: 700px;
    .item {
      &-image {
        display: flex;
        flex-wrap: wrap;
        img {
          width: 178px;
          height: 102px;
          object-fit: contain;
        }
        .single-item {
          margin: 0 20px 20px;
          position: relative;
          .item-key {
            width: 46px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 4px 0px 4px 0px;
            position: absolute;
            top: 0px;
            left: 0px;
          }
        }
      }
      &-html,
      &-text,
      &-syllable {
        .single-item {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 10px 0 10px 40px;
          width: 315px;
          min-height: 50px;
          line-height: 50px;
          font-size: 16px;
          margin-top: 30px;
          color: #3f4651;
          background: #f2f3f7;
          border-radius: 6px;
          box-sizing: border-box;
          .item-key {
            position: absolute;
            font-size: 16px;
            font-weight: 600;
            color: #aebac6;
            left: 16px;
          }
        }
      }
    }
  }
}
.common-panel .panel-content-reading-questions {
  .options {
    font-family: "pinyinFont";
  }
}
.panel-content {
  // 结果
  &-result {
    padding-top: 20px;
    margin: 0 !important;
    width: 100%;
    &.result-error,
    &.result-correct {
      p.error-tips {
        font-size: 14px;
        color: #fc5a5a;
        margin-bottom: 20px;
      }
      p.correct-tips {
        font-size: 14px;
        color: rgba(9, 203, 160, 1);
        margin-bottom: 20px;
      }
      .result-show {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .your-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 20px;
        }
      }
      p.correct-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
        margin-left: 45px;
      }
      .correct-box {
        background: rgba(251, 252, 255, 1);
        border: 1px solid rgba(242, 243, 247, 1);
        border-radius: 10px;
        padding: 20px;

        &-title {
          font-size: 14px;
          font-weight: bold;
          color: rgba(63, 70, 81, 1);
          margin-bottom: 10px;
        }
        &-answer {
          font-size: 14px;
          font-weight: 400;
          color: rgba(84, 89, 97, 1);
          line-height: 21px;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
